import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/Button";
import logoasniere from "../assets/img/logo.png";
import logobrive from "../assets/img/logobrive.png";
import logotoulouse from "../assets/img/logotoulouse.png";
import axios from "../axios/axiosInstance";
import React, { useState, useEffect } from "react";

import { Textarea } from "../components/ui/TextArea";

import { Label } from "../components/ui/Label";
import { Checkbox } from "../components/ui/Checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/Select";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/Tabs";
import { toast } from "sonner";

import { Link, useNavigate, useParams } from "react-router-dom";

import { Input } from "../components/ui/Input";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  CardDescription,
} from "../components/ui/Card";
import { Skeleton } from "../components/ui/Skeleton";
import { Alert, AlertDescription, AlertTitle } from "../components/ui/Alert";
import {
  UploadCloud,
  ArrowLeft,
  Send,
  AlertCircle,
  CheckCircle2,
} from "lucide-react";

export default function PostulerPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [annonce, setAnnonce] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    prenom: "",
    nom: "",
    email: "",
    telephone: "",
    cv: null,
    lettreMotivation: "",
    consent: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (type === "file") {
      setFormData((prev) => ({ ...prev, cv: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => setIsSubmitting(false), 1000);
  };
  useEffect(() => {
    if (!id) {
      setError("ID de l'annonce manquant ou invalide.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    axios
      .get(`annonces/${id}`)
      .then((res) => {
        setAnnonce(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.error(
          "Erreur lors de la récupération des détails de l'annonce :",
          err,
        );
        setError(
          err.response?.data?.detail ||
            err.message ||
            "Une erreur est survenue",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-12">
          <Skeleton className="h-12 w-3/4 mb-6" />
          <Skeleton className="h-8 w-1/2 mb-4" />
          <Skeleton className="h-24 w-full mb-6" />
          <Skeleton className="h-8 w-1/3 mb-4" />
          <Skeleton className="h-20 w-full mb-6" />
          <Skeleton className="h-10 w-32 mt-8" />
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-12 flex flex-col items-center justify-center">
          <Alert variant="destructive" className="w-full max-w-lg">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Erreur</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
          <Button variant="outline" asChild className="mt-6">
            <Link to="/offres-emploi">Retour aux offres</Link>
          </Button>
        </main>
        <Footer />
      </div>
    );
  }

  if (!annonce) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-12 text-center">
          <p>Aucune donnée d'annonce disponible.</p>
          <Button variant="outline" asChild className="mt-6">
            <Link to="/offres-emploi">Retour aux offres</Link>
          </Button>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-12">
        <Button
          variant="outline"
          size="sm"
          className="mb-8"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour aux détails de l'offre
        </Button>

        <Card className="max-w-2xl mx-auto shadow-lg border border-gray-200">
          <CardHeader className="bg-gray-100 p-6 rounded-t-lg">
            <CardDescription className="text-blue-600 font-semibold">
              Vous postulez pour l'offre :
            </CardDescription>
            <CardTitle className="text-2xl md:text-3xl font-bold text-gray-800">
              {annonce.title}
            </CardTitle>
            <p className="text-gray-600">À: {annonce.town}</p>
          </CardHeader>
          <form onSubmit={handleSubmit} className="space-y-6">
            <CardContent className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <Label
                    htmlFor="prenom"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Prénom *
                  </Label>
                  <br></br>
                  <Input
                    id="prenom"
                    name="prenom"
                    type="text"
                    required
                    value={formData.prenom}
                    onChange={handleInputChange}
                    placeholder="Votre prénom"
                  />
                  <br></br>
                </div>
                <div>
                  <Label
                    htmlFor="nom"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Nom *
                  </Label>
                  <br></br>
                  <Input
                    id="nom"
                    name="nom"
                    type="text"
                    required
                    value={formData.nom}
                    onChange={handleInputChange}
                    placeholder="Votre nom"
                  />
                </div>
              </div>
              <div>
                <Label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email *
                </Label>
                <br></br>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Votre adresse email"
                />
                <br></br>
              </div>
              <div>
                <Label
                  htmlFor="telephone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Téléphone
                </Label>
                <br></br>
                <Input
                  id="telephone"
                  name="telephone"
                  type="tel"
                  value={formData.telephone}
                  onChange={handleInputChange}
                  placeholder="Votre numéro de téléphone"
                />
                <br></br>
              </div>
              <div>
                <Label
                  htmlFor="cv"
                  className="block text-sm font-medium text-gray-700"
                >
                  Votre CV *
                </Label>
                <br></br>
                <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                  <div className="space-y-1 text-center">
                    <UploadCloud className="mx-auto h-12 w-12 text-gray-400" />
                    <label
                      htmlFor="cv"
                      className="cursor-pointer bg-white rounded-md text-blue-600 hover:text-blue-500"
                    >
                      <span>Téléchargez un fichier</span>
                      <input
                        id="cv"
                        name="cv"
                        type="file"
                        className="sr-only"
                        onChange={handleInputChange}
                        accept=".pdf,.doc,.docx"
                        required
                      />
                    </label>
                    {formData.cv && (
                      <p className="text-sm text-green-600">
                        Fichier sélectionné : {formData.cv.name}
                      </p>
                    )}
                  </div>
                </div>
                <br></br>
              </div>

              <br></br>

              <div className="flex items-start">
                <Checkbox
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onCheckedChange={(checked) =>
                    setFormData((prev) => ({ ...prev, consent: checked }))
                  }
                />
                <Link to="/politique-confidentialite">
                  <Label
                    htmlFor="consent"
                    className="ml-3 text-sm font-medium text-gray-700 underline"
                  >
                    J'accepte la politique de confidentialité
                  </Label>
                </Link>
              </div>
            </CardContent>
            <CardFooter className="p-6 bg-gray-100 rounded-b-lg">
              <br></br>
              <br></br>
              <Button
                type="submit"
                className="mx-auto flex items-center justify-center w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  "Envoi..."
                ) : (
                  <>
                    <Send className="mr-2 h-5 w-5" /> Soumettre ma candidature
                  </>
                )}
              </Button>
            </CardFooter>
          </form>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
